const RETRYABLE_GATEWAY_STATUSES = new Set([502, 503, 504]);

export function isRetryableStatus(status: number): boolean {
  return RETRYABLE_GATEWAY_STATUSES.has(status);
}
